import actionCreatorFactory from 'typescript-fsa';

export const actionCreator = actionCreatorFactory();

export default actionCreator;
